module.exports = "<div class=\"quickview-wrapper\" [class.open]=\"open\" id=\"quickview-wrapper\">\n\n</div>"